// import Swiper and modules styles from npm
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, Thumbs, FreeMode, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


function loadSwiperCarousel(carouselID) {

    const carouselElement = '#' + carouselID; //prefix the ID with # to target the element in the DOM

    const options = {

        modules: [Navigation, Pagination, Scrollbar, Thumbs, FreeMode, Autoplay],

        // If we need pagination
        pagination: {
            el: '.swiper-pagination-'+carouselID,
            type: 'bullets',
            clickable: true,
            dynamicBullets: true, // Enables dynamic pagination
            dynamicMainBullets: 3
        },
        spaceBetween: '16px',

         // Navigation arrows
        navigation: {
            nextEl: '.carousel__arrow--right-'+carouselID, //target the specific carousel using the unique ID
            prevEl: '.carousel__arrow--left-'+carouselID,
        },
        grabCursor: true,
        keyboard: {
            enabled: true,
        },

        //Responsive
        centeredSlides: true, //only for mobile
        slidesPerView: 'auto',
        // freeMode: {
        //     enabled: true,
        //     sticky: true,
        // },
        breakpoints: {
            600: { //upwards of 600
                centeredSlides: false,
                freeMode: false
            },
        },

    }

    // init Swiper:
    const swiper = new Swiper(carouselElement, options);
}

function initialiseCarouselGetValues() { 

    const getAllCarousels = document.querySelectorAll('.related-articles');

    for (const carousel of getAllCarousels) { 
        const carouselID = carousel.getAttribute('id');

        console.log('carouselID', carouselID, 'carousel', carousel);
        loadSwiperCarousel(carouselID)
    }
}

document.addEventListener("DOMContentLoaded", () => {

    initialiseCarouselGetValues()
    

    //awaiting the block editor before loading 
    if(window._wpLoadBlockEditor){

        window._wpLoadBlockEditor.then( function() {

            setTimeout(() => {

                initialiseCarouselGetValues()       
                
            },1000)

        });
    }
})
